import React from "react";
import Model from "../../common/Model";
import { useFormik } from "formik";
import * as Yup from "yup";

const SettingModel = ({ initialData, onClose, onSubmit }) => {
  const validationSchema = Yup.object().shape({
    isRazorpay: Yup.boolean(),
    isPhonePe: Yup.boolean(),

    apiKey: Yup.string().when("isRazorpay", {
      is: true,
      then: (s) => s.required("Razorpay API Key is required"),
      otherwise: (s) => s,
    }),
    apiSecret: Yup.string().when("isRazorpay", {
      is: true,
      then: (s) => s.required("Razorpay API Secret is required"),
      otherwise: (s) => s,
    }),

    phonePeApiKey: Yup.string().when("isPhonePe", {
      is: true,
      then: (s) => s.required("PhonePe API Key is required"),
      otherwise: (s) => s,
    }),
    phonePeApiSecret: Yup.string().when("isPhonePe", {
      is: true,
      then: (s) => s.required("PhonePe API Secret is required"),
      otherwise: (s) => s,
    }),
    phonePeVersion: Yup.string().when("isPhonePe", {
      is: true,
      then: (s) => s.required("PhonePe Version is required"),
      otherwise: (s) => s,
    }),
  });

  const formik = useFormik({
    initialValues: {
      apiKey: initialData?.apiKey || "",
      apiSecret: initialData?.apiSecret || "",
      isRazorpay: initialData?.isRazorpay || false,

      phonePeApiKey: initialData?.phonePeApiKey || "",
      phonePeApiSecret: initialData?.phonePeApiSecret || "",
      phonePeVersion: initialData?.phonePeVersion || "",
      isPhonePe: initialData?.isPhonePe || false,

      isMultiTabOpen: initialData?.isMultiTabOpen || false,
    },
    validationSchema,
    onSubmit,
  });

  const { values, handleChange, handleSubmit, setFieldValue } = formik;
  return (
    <Model closeModal={onClose} title={`Edit Setting`} isForm={true} handleSubmit={handleSubmit}>
      <div className="w-full">
        <label className="capitalize text-base font-medium text-foreground">Razorpay API Key</label>
        <input className="w-full text-base p-2 rounded-xl border border-border focus:outline-none focus:border-primary" type="text" placeholder="Enter Razorpay API Key" name="apiKey" value={values.apiKey} onChange={handleChange} />
        {formik.touched.apiKey && formik.errors.apiKey && <div className="text-red-500 text-sm">{formik.errors.apiKey}</div>}
      </div>
      <div className="w-full mt-4">
        <label className="capitalize text-base font-medium text-foreground">Razorpay Api Secret</label>
        <input className="w-full text-base p-2 rounded-xl border border-border focus:outline-none focus:border-primary" type="text" placeholder="Enter Razorpay API Secret" name="apiSecret" value={values.apiSecret} onChange={handleChange} />
        {formik.touched.apiSecret && formik.errors.apiSecret && <div className="text-red-500 text-sm">{formik.errors.apiSecret}</div>}
      </div>
      <div className="flex items-center gap-3 mt-1 mb-4">
        <span className="text-sm font-medium text-foreground capitalize">Razorpay Active :</span>
        <div className="relative inline-block w-12 h-6">
          <label className="flex cursor-pointer select-none items-center">
            <div className="relative">
              <input
                className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-secondary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-secondary checked:focus:before:ml-[1.0625rem]"
                type="checkbox"
                role="switch"
                id="flexSwitchChecked"
                checked={values.isRazorpay}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFieldValue("isRazorpay", checked);
                  if (checked) setFieldValue("isPhonePe", false);
                }}
              />
            </div>
          </label>
        </div>
      </div>
      <div className="w-full">
        <label className="capitalize text-base font-medium text-foreground">Phonepe API Key</label>
        <input className="w-full text-base p-2 rounded-xl border border-border focus:outline-none focus:border-primary" type="text" placeholder="Enter Phonepe API Key" name="phonePeApiKey" value={values.phonePeApiKey} onChange={handleChange} />
        {formik.touched.phonePeApiKey && formik.errors.phonePeApiKey && <div className="text-red-500 text-sm">{formik.errors.phonePeApiKey}</div>}
      </div>
      <div className="w-full mt-4">
        <label className="capitalize text-base font-medium text-foreground">Phonepe Api Secret</label>
        <input className="w-full text-base p-2 rounded-xl border border-border focus:outline-none focus:border-primary" type="text" placeholder="Enter Phonepe API Secret" name="phonePeApiSecret" value={values.phonePeApiSecret} onChange={handleChange} />
        {formik.touched.phonePeApiSecret && formik.errors.phonePeApiSecret && <div className="text-red-500 text-sm">{formik.errors.phonePeApiSecret}</div>}
      </div>
      <div className="w-full mt-4">
        <label className="capitalize text-base font-medium text-foreground">Phonepe Version</label>
        <input className="w-full text-base p-2 rounded-xl border border-border focus:outline-none focus:border-primary" pattern="[0-9]*" type="text" inputMode="numeric" placeholder="Enter Phonepe Version" name="phonePeVersion" value={values.phonePeVersion} onChange={handleChange} />
        {formik.touched.phonePeVersion && formik.errors.phonePeVersion && <div className="text-red-500 text-sm">{formik.errors.phonePeVersion}</div>}
      </div>
      <div className="flex items-center gap-3 mt-1 mb-4">
        <span className="text-sm font-medium text-foreground capitalize">Phonepe Active :</span>
        <div className="relative inline-block w-12 h-6">
          <label className="flex cursor-pointer select-none items-center">
            <div className="relative">
              <input
                className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-secondary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-secondary checked:focus:before:ml-[1.0625rem]"
                type="checkbox"
                role="switch"
                id="flexSwitchChecked"
                checked={values.isPhonePe}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFieldValue("isPhonePe", checked);
                  if (checked) setFieldValue("isRazorpay", false);
                }}
              />
            </div>
          </label>
        </div>
      </div>
      <div className="flex items-center gap-3 mt-4">
        <span className="text-sm font-medium text-foreground capitalize">Multi tab (warning) :</span>
        <div className="relative inline-block w-12 h-6">
          <label className="flex cursor-pointer select-none items-center">
            <div className="relative">
              <input className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-secondary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-secondary checked:focus:before:ml-[1.0625rem]" type="checkbox" role="switch" id="flexSwitchChecked" checked={values.isMultiTabOpen} onChange={(e) => setFieldValue("isMultiTabOpen", e.target.checked)} />
            </div>
          </label>
        </div>
      </div>
    </Model>
  );
};

export default SettingModel;
